export interface BrandPresetColor {
  name: string
  hex: string
}

export const BRAND_PRESET_COLORS: BrandPresetColor[] = [
  { name: 'Blue', hex: '#2563EB' },
  { name: 'Navy', hex: '#1E3A8A' },
  { name: 'Purple', hex: '#7C3AED' },
  { name: 'Pink', hex: '#EC4899' },
  { name: 'Red', hex: '#DC2626' },
  { name: 'Orange', hex: '#EA580C' },
  { name: 'Amber', hex: '#D97706' },
  { name: 'Yellow', hex: '#CA8A04' },
  { name: 'Lime', hex: '#65A30D' },
  { name: 'Green', hex: '#16A34A' },
  { name: 'Teal', hex: '#0D9488' },
  { name: 'Cyan', hex: '#0891B2' },
  { name: 'Sky', hex: '#0284C7' },
  { name: 'Indigo', hex: '#4F46E5' },
  { name: 'Slate', hex: '#475569' },
]

export const DEFAULT_BRAND_PRIMARY_HEX = '#65A30D'
export const DEFAULT_BRAND_SECONDARY_HEX = '#0D9488'
export const DEFAULT_BRAND_TERTIARY_HEX = '#2563EB'
